var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sec-title", { attrs: { showHelp: _vm.showHelp } }),
      _vm._v(" "),
      _c(
        "confirm",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowHelp,
              expression: "isShowHelp"
            }
          ],
          staticClass: "small",
          attrs: {
            showMask: true,
            singleBtn: true,
            title: _vm.$t("walletFullNode.help.title"),
            closeIcon: true,
            close: _vm.close,
            leftBtnTxt: _vm.$t("btn.understand"),
            leftBtnClick: _vm.close
          }
        },
        [
          _c("div", { staticClass: "help-t" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.help.t2")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-t" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.help.t3")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-txt distance" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.help.t1")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-txt" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.help.txt1")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-txt" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.help.txt2")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "help-txt" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.help.txt3")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }